import { LocationInput } from '@graphql/generated';
import { useTranslation } from '@shared/core/i18n';
import { distanceInMiles } from '@shared/utils/distanceInMiles';
import { useCallback } from 'react';

export const useTranslations = () => {
  const { t } = useTranslation('websiteEditor');
  const translations = t('customPage', 'travelMap', 'guestHotelBookings');

  const getDistanceFromVenue = useCallback(
    (point1?: LocationInput | null, point2?: LocationInput | null) => {
      return translations.distanceFromVenue({ distance: `${Math.round(distanceInMiles(point1, point2) || 0)} mi` });
    },
    [translations],
  );

  const getBookingRecordTranslations = () => {
    return {
      translateValue: (value: string) => translations.translateValue({ value }),
      guestName: (firstName: string, lastName: string) => translations.guestName({ firstName, lastName }),
      distanceFromVenue: getDistanceFromVenue,
    };
  };

  return {
    getBookingRecordTranslations,
  };
};
